import truncate from 'lodash/truncate';

export default {
  methods: {
    truncateLongText(text, truncateConfig = {}) {
      let textLength = text.length;
      if (typeof truncateConfig[this.$vuetify.breakpoint.name] !== 'undefined') {
        textLength = truncateConfig[this.$vuetify.breakpoint.name];
      }

      return truncate(text, { length: textLength, separator: '...' });
    },
  },
};
